import { render, staticRenderFns } from "./kcb-cert.vue?vue&type=template&id=6a9a6898&"
import script from "./kcb-cert.vue?vue&type=script&lang=js&"
export * from "./kcb-cert.vue?vue&type=script&lang=js&"
import style0 from "./kcb-cert.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports